import { render } from "./SuccessForm.vue?vue&type=template&id=b9b7b560"
import script from "./SuccessForm.vue?vue&type=script&lang=js"
export * from "./SuccessForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__